import { Button } from '@habitech/call-to-action'
import React from 'react'

interface ExpandValiditySectionProps {
    total_to_expire: number
    total_interest: number
    total_edit: number
    total_expand: number
    loadingExpand: boolean
    handleExpandValidity: (type: string) => void
}

const ExpandValiditySection = ({ total_to_expire, total_interest, total_edit, total_expand, loadingExpand, handleExpandValidity }: ExpandValiditySectionProps) => {
    return (
        <>
            <div className="containerLabel gap-10  no-flex">
                <span className="label green">Expandir vigencia:</span>
                <div className="containerLabel gap-10">
                    <span className="label">Total:</span>
                    <div className="label-status">{total_to_expire}</div>
                    <Button
                        dataId="btn-expand"
                        originType="pcom"
                        size="small"
                        loading={loadingExpand}
                        onClick={() => handleExpandValidity('updated-interest')}
                    >
                        Expandir todas
                    </Button>
                </div>
                {total_interest > 0 && (
                    <div className="containerLabel gap-10 space-between">
                        <span className="label">Mayor interes:</span>
                        <div className="label-status">{total_interest}</div>{' '}
                        <Button
                            dataId="btn-expand"
                            originType="pcom"
                            dataTestId='btn-expand-interest'
                            size="small"
                            variant="stroke"
                            loading={loadingExpand}
                            onClick={() => handleExpandValidity('interest')}
                        >
                            Expandir
                        </Button>
                    </div>
                )}
                {total_edit > 0 && (
                    <div className="containerLabel gap-10 space-between">
                        <span className="label">Recien editadas:</span>
                        <div className="label-status">{total_edit}</div>{' '}
                        <Button
                            dataId="btn-expand"
                            originType="pcom"
                            dataTestId='btn-expand-updated'
                            size="small"
                            variant="stroke"
                            loading={loadingExpand}
                            onClick={() => handleExpandValidity('updated')}
                        >
                            Expandir
                        </Button>
                    </div>
                )}
            </div>

            {
                total_expand ? (<div className="containerLabel gap-10">
                    <span className="label">Expansiones realizadas: {total_expand}</span>
                </div>) : null
            }
        </>
    )
}

export default ExpandValiditySection